import { render, staticRenderFns } from "./supplierRFQEdit_v2.vue?vue&type=template&id=0a8713fc&scoped=true&"
import script from "./supplierRFQEdit_v2.vue?vue&type=script&lang=js&"
export * from "./supplierRFQEdit_v2.vue?vue&type=script&lang=js&"
import style0 from "./supplierRFQEdit_v2.vue?vue&type=style&index=0&id=0a8713fc&lang=less&scoped=true&"
import style1 from "./supplierRFQEdit_v2.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8713fc",
  null
  
)

component.options.__file = "supplierRFQEdit_v2.vue"
export default component.exports